import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Spinner, Row, Col, Card, Badge, Alert } from 'react-bootstrap';

/**
 * Modal para seleccionar y confirmar la creación de una suscripción manual.
 * Extraído de ServiciosContratados.js para mantener separación de responsabilidades.
 */
const ModalSeleccionarSuscripcion = ({
    show,
    onHide,
    cargando,
    suscripcionesDisponibles,
    idProductoRenovacionSeleccionado,
    onSeleccionarProducto,
    onConfirmar,
    procesando
}) => {
    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Generar Link de Suscripci&oacute;n</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                {cargando ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" className="mb-3" />
                        <h6 className="text-600">Cargando suscripciones disponibles...</h6>
                    </div>
                ) : (
                    <div>
                        <p className="text-600 mb-3">
                            Selecciona el plan de suscripci&oacute;n para generar el link de pago recurrente en Stripe. El cliente deber&aacute; realizar el pago a trav&eacute;s del link para activar la suscripci&oacute;n:
                        </p>
                        <Row className="g-3">
                            {suscripcionesDisponibles.length === 0 && (
                                <Col xs={12}>
                                    <Alert variant="warning" className="text-center">
                                        No hay suscripciones disponibles para este cliente.
                                    </Alert>
                                </Col>
                            )}
                            {suscripcionesDisponibles.map(opcion => {
                                const isSelected =
                                    String(idProductoRenovacionSeleccionado) ===
                                    String(opcion.idProductoPrecio);
                                return (
                                    <Col xs={12} sm={6} md={4} key={opcion.idProductoPrecio}>
                                        <Card
                                            onClick={() =>
                                                onSeleccionarProducto(opcion.idProductoPrecio)
                                            }
                                            style={{
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease-in-out',
                                                transform: isSelected ? 'scale(1.02)' : 'none'
                                            }}
                                            className={`h-100 border-2 ${
                                                isSelected
                                                    ? 'border-primary shadow-sm'
                                                    : 'border-200 hover-border-primary'
                                            }`}
                                        >
                                            <Card.Body className="d-flex flex-column justify-content-between p-3">
                                                <div>
                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                        <h6
                                                            className={`mb-0 fw-bold ${
                                                                isSelected ? 'text-primary' : 'text-800'
                                                            }`}
                                                        >
                                                            {opcion.vNombreProducto}
                                                        </h6>
                                                        {isSelected && (
                                                            <Badge bg="primary" pill className="ms-2">
                                                                <i className="fas fa-check"></i>
                                                            </Badge>
                                                        )}
                                                    </div>
                                                    <Badge
                                                        bg={isSelected ? 'primary' : 'secondary'}
                                                        className="mb-3"
                                                    >
                                                        {opcion.vTipoRenovacion}
                                                    </Badge>
                                                </div>
                                                <div className="mt-auto">
                                                    <hr className="my-2" />
                                                    <h4
                                                        className={`mb-0 fw-bold ${
                                                            isSelected ? 'text-primary' : 'text-900'
                                                        }`}
                                                    >
                                                        ${Number(opcion.dTotal).toFixed(2)}{' '}
                                                        <span className="fs--1 fw-normal text-500">
                                                            {opcion.vMoneda}
                                                        </span>
                                                    </h4>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={onHide}
                    disabled={procesando}
                >
                    Cancelar
                </Button>
                <Button
                    variant="primary"
                    onClick={onConfirmar}
                    disabled={
                        cargando ||
                        !idProductoRenovacionSeleccionado ||
                        procesando
                    }
                >
                    {procesando ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Generando...
                        </>
                    ) : (
                        'Generar y Copiar Link'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalSeleccionarSuscripcion.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    cargando: PropTypes.bool.isRequired,
    suscripcionesDisponibles: PropTypes.arrayOf(
        PropTypes.shape({
            idProductoPrecio: PropTypes.number,
            vNombreProducto: PropTypes.string,
            vTipoRenovacion: PropTypes.string,
            dTotal: PropTypes.number,
            vMoneda: PropTypes.string
        })
    ).isRequired,
    idProductoRenovacionSeleccionado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSeleccionarProducto: PropTypes.func.isRequired,
    onConfirmar: PropTypes.func.isRequired,
    procesando: PropTypes.bool.isRequired
};

ModalSeleccionarSuscripcion.defaultProps = {
    idProductoRenovacionSeleccionado: ''
};

export default ModalSeleccionarSuscripcion;
